var map = {
	"./icons/block": 205,
	"./icons/block.svg": 205,
	"./icons/eye": 206,
	"./icons/eye.svg": 206,
	"./icons/pen": 207,
	"./icons/pen.svg": 207,
	"./icons/reorder": 208,
	"./icons/reorder.svg": 208,
	"./icons/share": 209,
	"./icons/share.svg": 209,
	"./icons/three-dots-ellipsis": 210,
	"./icons/three-dots-ellipsis.svg": 210,
	"./icons/trash": 211,
	"./icons/trash.svg": 211,
	"./icons/unblock": 212,
	"./icons/unblock.svg": 212,
	"./placeholders/avatar": 213,
	"./placeholders/avatar.png": 213,
	"./webfonts/uicons-bold-rounded.eot": 355,
	"./webfonts/uicons-bold-rounded.woff": 356,
	"./webfonts/uicons-bold-rounded.woff2": 357,
	"./webfonts/uicons-regular-rounded.eot": 358,
	"./webfonts/uicons-regular-rounded.woff": 359,
	"./webfonts/uicons-regular-rounded.woff2": 360,
	"./webfonts/uicons-solid-rounded.eot": 361,
	"./webfonts/uicons-solid-rounded.woff": 362,
	"./webfonts/uicons-solid-rounded.woff2": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;